import { render, staticRenderFns } from "./banner-cookies.vue?vue&type=template&id=927f8b5a&"
import script from "./banner-cookies.vue?vue&type=script&lang=js&"
export * from "./banner-cookies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('927f8b5a')) {
      api.createRecord('927f8b5a', component.options)
    } else {
      api.reload('927f8b5a', component.options)
    }
    module.hot.accept("./banner-cookies.vue?vue&type=template&id=927f8b5a&", function () {
      api.rerender('927f8b5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/banner-cookies.vue"
export default component.exports